export const formatTotalTime = (time) => {
  const hours = time?.hours.toString();
  const minutes = time?.minutes.toString();

  return `${hours.length < 2 ? "0"+hours : hours}:${
    minutes.length < 2 ? "0" + minutes : minutes
  }`
}
